import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';  // Add Outlet import
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

function PrivateRoute() {  // Remove children parameter
  const { user, loading } = useAuth();
  
  console.log('PrivateRoute - user:', user, 'loading:', loading);  // Debug log

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return user ? <Outlet /> : <Navigate to="/login" />;  // Use Outlet instead of children
}

export default PrivateRoute;
